import React, { useState, useEffect } from "react";
import { useFont } from "../../../contexts/FontContext/FontContext";
import styles from "./ExchangeItemSelect.module.css";

const ExchangeItemSelect = ( { exchangeProducts, visibleChoices, setVisibleChoices, setRenderExchangeItemSelect, setRenderItemExchange, flattenedProducts, setFlattenedProducts, linkType, setNewItemsSelectedOptions } ) => {
	const [continueButtonClass, setContinueButtonClass] = useState("dimmed");

	// Sequential fade in animation
	useEffect(() => {
		if (exchangeProducts) {
			exchangeProducts.forEach((_, index) => {
				setTimeout(() => { setVisibleChoices((prev) => [...prev, index]); }, index * 150);
			});
		}
	}, [exchangeProducts]);

	//cant continue to ItemExchange unless at least one item is selected!
	useEffect(() => {
		const hasSelections = flattenedProducts.some(product => product.selected);
		setContinueButtonClass(hasSelections ? "fade_in" : "dimmed");
	}, [flattenedProducts]);

	const toggleItem = (uniqueId) => {
		setFlattenedProducts((prev) => prev.map((product) => product.unique_id === uniqueId ? { ...product, selected: !product.selected } : product));
		// Remove from newItemsSelectedOptions if it was deselected
		const target = flattenedProducts.find(product => product.unique_id === uniqueId);
		if (target?.selected) { setNewItemsSelectedOptions(prev => prev.filter(item => item.unique_id !== uniqueId) ); } // If it was selected before this toggle (meaning it's now being deselected), remove it
	};

	const continueButton = () => {
		if (continueButtonClass === "dimmed") { return; }
		if (linkType === "exchange") { 
			setRenderExchangeItemSelect(false);
			setRenderItemExchange(true);
		} else { setRenderExchangeItemSelect(false); }
	}

	return (
		<>
			<p className={`titles ${linkType === 'exchange' ? styles.exchange_link_title : styles.return_link_title} fade_in`}>Select the items you'd like to {linkType}.</p>
			<div className={`${linkType === "exchange" ? styles.exchange_item_select_container : styles.return_item_select_container}`}>
				{flattenedProducts.map((product) => (
					<div key={product.unique_id} className={`${styles.exchange_product_wrapper} fade_in`} onClick={() => toggleItem(product.unique_id)} >
						<img src={product.product_image} alt="product_image" className={styles.exchange_product_image} />
						<div className={styles.product_text_box}>
							<p className={styles.exchange_product_title}>{product.product_title} {product.product_variant ? ` / ${product.product_variant}` : ""}</p>
						</div>
						<img className={styles.item_select_icon} src={`${process.env.PUBLIC_URL}/images/${product.selected ? "checked_item.png" : "unchecked_item.png"}`} alt={product.selected ? "Checked" : "Unchecked"} />
					</div>
				))}
			</div>
			<div className={`continue_button ${continueButtonClass === "dimmed" ? styles.dimmed : styles.fade_in} ${linkType === "exchange" ? styles.exchange_link_continue_button : styles.return_link_continue_button}`} onClick={() => { continueButton(); }}>Continue</div>
		</>
	);
};

export default ExchangeItemSelect;